import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import ListItemLink from 'components/Common/ListItemLink';
import { t } from 'utils/translates';
import TaskInfoBlockAsExecutor from '../../../../../components/Tasks/TaskView/TaskInfoBlockAsExecutor';

import ExecDescBlock from '../../../../../components/Tasks/_common/ExecDescBlock';
import CommentsIn from '../../../../../components/Comment/ReducerWrappers/CommentsIn';
import TasksExecsListAuthUserByTask from '../../../../../components/Tasks/TasksExecsLists/TasksExecsListAuthUserByTask';
import CreateExecButton from './CreateExecButton';

// eslint-disable-next-line react/prefer-stateless-function
class TaskViewAsExecutor extends Component {
  render() {
    return (
      <React.Fragment>
        <TaskInfoBlockAsExecutor task={this.props.task} />
        <div className="panel panel-default visible-xs visible-sm">
          <div className="panel-bar bg-main">
            <div className="hor-scroll hor-scroll_xs">
              <ul className="nav nav-tabs nav-tabs-lg hor-scroll-wrapper">
                <ListItemLink
                  to={`/earn-money/task-view/${this.props.task.id}/desc`}
                >
                  {t('Описание')}
                </ListItemLink>
                <ListItemLink
                  to={`/earn-money/task-view/${this.props.task.id}/reviews`}
                >
                  {t('Отзывы')}{' '}
                  <span className="badge">
                    {this.props.task.taskCommentsStat.total}
                  </span>
                </ListItemLink>
                <ListItemLink
                  to={`/earn-money/task-view/${this.props.task.id}/executions`}
                >
                  {t('Мои выполнения')}
                </ListItemLink>
              </ul>
            </div>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`/earn-money/task-view/${this.props.task.id}`}
            render={() => (
              <Redirect
                from={`/earn-money/task-view/${this.props.task.id}`}
                to={`/earn-money/task-view/${this.props.task.id}/desc`}
              />
            )}
          />
          <Route
            path={`/earn-money/task-view/${this.props.task.id}/desc`}
            render={() => (
              <React.Fragment>
                <ExecDescBlock {...this.props} />
                <TasksExecsListAuthUserByTask taskId={this.props.task.id} />
                <div className="visible-xs visible-sm">
                  <CreateExecButton
                    modalIndex={'mobil'}
                    task={this.props.task}
                  />
                </div>
              </React.Fragment>
            )}
          />
          <Route
            exact
            path={`/earn-money/task-view/${this.props.task.id}/reviews`}
            render={() => (
              <CommentsIn
                key={`/earn-money/task-view/${this.props.task.id}/reviews`}
                modelClass="Tasks"
                modelId={this.props.task.id}
                commentsOwnerId={this.props.task.ownerId}
                commentsInStat={this.props.task.taskCommentsStat}
              />
            )}
          />
          <Route
            path={`/earn-money/task-view/${this.props.task.id}/reviews/likes`}
            render={() => (
              <CommentsIn
                key={`/earn-money/task-view/${this.props.task.id}/reviews/likes`}
                modelClass="Tasks"
                modelId={this.props.task.id}
                queryParamsStatic={{ like: 1 }}
                commentsOwnerId={this.props.task.ownerId}
                commentsInStat={this.props.task.taskCommentsStat}
              />
            )}
          />
          <Route
            path={`/earn-money/task-view/${this.props.task.id}/reviews/dislikes`}
            render={() => (
              <CommentsIn
                key={`/earn-money/task-view/${this.props.task.id}/reviews/dislikes`}
                modelClass="Tasks"
                modelId={this.props.task.id}
                queryParamsStatic={{ like: -1 }}
                commentsOwnerId={this.props.task.ownerId}
                commentsInStat={this.props.task.taskCommentsStat}
              />
            )}
          />
          <Route
            path={`/earn-money/task-view/${this.props.task.id}/reviews/neutral`}
            render={() => (
              <CommentsIn
                key={`/earn-money/task-view/${this.props.task.id}/reviews/neutral`}
                modelClass="Tasks"
                modelId={this.props.task.id}
                queryParamsStatic={{ like: 0 }}
                commentsOwnerId={this.props.task.ownerId}
                commentsInStat={this.props.task.taskCommentsStat}
              />
            )}
          />
          <Route
            path={`/earn-money/task-view/${this.props.task.id}/executions`}
            render={() => (
              <TasksExecsListAuthUserByTask taskId={this.props.task.id} />
            )}
          />
        </Switch>
      </React.Fragment>
    );
  }
}

TaskViewAsExecutor.propTypes = {
  // IN
  task: PropTypes.shape({
    id: PropTypes.number.isRequired,
    ownerId: PropTypes.number.isRequired,
    taskCommentsStat: PropTypes.shape({
      total: PropTypes.string
    })
  }).isRequired
};
export default withRouter(TaskViewAsExecutor);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/TaskViewAsExecutor/TaskViewAsExecutor.js